import { render, staticRenderFns } from "./send.vue?vue&type=template&id=016fc7e3&scoped=true"
import script from "./send.vue?vue&type=script&lang=ts"
export * from "./send.vue?vue&type=script&lang=ts"
import style0 from "./send.vue?vue&type=style&index=0&id=016fc7e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016fc7e3",
  null
  
)

export default component.exports